<div class="card mt-3" [formGroup]="form">
    <div class="card-body">
        <div class="row">
            <div class="col-md-8">
                <h5 class="card-title main-blue">
                    {{ "CampDetails.Visiblity" | translate }}
                </h5>
            </div>
            <div class="col-md-4">
                @if (state.canEdit | async) {
                    <button
                        class="btn btn-action btn-primary pull-right"
                        [disabled]="isOtherItemEdited"
                        bcClick
                        hznTestId="camp-visibility-edit"
                        (clicked)="edit()"
                    >
                        {{ "General.Edit" | translate }}
                    </button>
                }
            </div>
        </div>
        <div class="card-text">
            <div class="row">
                <div class="col-sm-2 bolded">
                    {{ "CampDetails.VisibleInConnect" | translate }}
                </div>
                <div class="col-sm-10" hznTestId="camp-visibility-visible">
                    {{ form.controls.isVisibleToMembers.value | yesno }}
                </div>
            </div>
        </div>
        <div class="card-text">
            <div class="row">
                <div class="col-sm-2 bolded">
                    {{ "CampDetails.DisplayedName" | translate }}
                </div>
                <div class="col-sm-10" hznTestId="camp-visibility-display-name">
                    {{ form.controls.displayName.value }}
                </div>
            </div>
        </div>
        <div class="card-text">
            <div class="row">
                <div class="col-sm-2 bolded">
                    {{ "CampDetails.ShortDescription" | translate }}
                </div>
                <div class="col-sm-10" hznTestId="camp-visibility-short-description">
                    {{ form.controls.shortDescription.value }}
                </div>
            </div>
        </div>
        <div class="card-text">
            <div class="row">
                <div class="col-sm-2 bolded">
                    {{ "CampDetails.LongDescription" | translate }}
                </div>
                <div class="col-sm-10" hznTestId="camp-visibility-description">
                    {{ form.controls.description.value }}
                </div>
            </div>
        </div>

        <div class="card-text">
            <div class="row">
                <div class="col-sm-2 bolded">
                    {{ "CampDetails.MemberWeeklyPrice" | translate }}
                </div>
                <div class="col-sm-10" hznTestId="camp-visibility-member-weekly-price">
                    {{
                        form.controls.memberWeeklyPrice.value | currency: "USD"
                    }}
                </div>
            </div>
        </div>
        <div class="card-text">
            <div class="row">
                <div class="col-sm-2 bolded">
                    {{ "CampDetails.GuestWeeklyPrice" | translate }}
                </div>
                <div class="col-sm-10" hznTestId="camp-visibility-guest-weekly-price">
                    {{ form.controls.guestWeeklyPrice.value | currency: "USD" }}
                </div>
            </div>
        </div>
    </div>
</div>
